import { onMounted, onUnmounted } from 'vue'

export function useAdminAssets() {
    const adminStyles = [
        { href: require('@/assets/adminlte/plugins/fontawesome-free/css/all.min.css') },
        { href: require('@/assets/adminlte/plugins/tempusdominus-bootstrap-4/css/tempusdominus-bootstrap-4.min.css') },
        { href: require('@/assets/adminlte/plugins/icheck-bootstrap/icheck-bootstrap.min.css') },
        { href: require('@/assets/adminlte/plugins/jqvmap/jqvmap.min.css') },
        { href: require('@/assets/adminlte/css/adminlte.min.css') },
        { href: require('@/assets/adminlte/plugins/overlayScrollbars/css/OverlayScrollbars.min.css') },
        { href: require('@/assets/adminlte/plugins/daterangepicker/daterangepicker.css') },
        { href: require('@/assets/adminlte/plugins/summernote/summernote-bs4.css') }
    ]

    const activeTags = []

    onMounted(() => {
        document.body.classList.add('admin-panel')

        adminStyles.forEach(styleDef => {
            let hrefUrl = styleDef.href
            if (hrefUrl && typeof hrefUrl === 'object' && hrefUrl.default) {
                hrefUrl = hrefUrl.default
            }

            if (!document.querySelector(`link[href="${hrefUrl}"]`)) {
                const link = document.createElement('link')
                link.rel = 'stylesheet'
                link.href = hrefUrl
                link.setAttribute('data-admin-asset', 'true') 
                
                document.head.appendChild(link)
                activeTags.push(link)
            }
        })
    })

    onUnmounted(() => {
        document.body.classList.remove('admin-panel')

        activeTags.forEach(tag => {
            if (tag && tag.parentNode) {
                tag.parentNode.removeChild(tag)
            }
        })
        
        document.querySelectorAll('link[data-admin-asset="true"]').forEach(el => el.remove())
    })
}